import { DashboardActionTypes } from './constants';
import { DashboardAction } from './actions';

export interface DashboardState {
    loading: boolean;
    data: any;
    error: string | null;
}

const initialState: DashboardState = {
    loading: false,
    data: null,
    error: null,
};

const dashboardReducer = (state: DashboardState = initialState, action: DashboardAction): DashboardState => {
    switch (action.type) {
        case DashboardActionTypes.DASHBOARD_OUTLETS:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case DashboardActionTypes.DASHBOARD_OUTLETS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null,
            };

        case DashboardActionTypes.DASHBOARD_OUTLETS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };

        default:
            return state;
    }
};

export default dashboardReducer;
